var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.getUserSymbol() === 'tk' || _vm.getUserSymbol() === 'sh' || _vm.getUserSymbol() === 'llpb')?_c('ion-buttons',{attrs:{"slot":"end"},slot:"end"},[_c('ion-button',{on:{"click":_vm.showClipboard}},[_c('ion-icon',{attrs:{"slot":"icon-only","name":"apps"},slot:"icon-only"})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }